import SimilarJobsResultList from "../../jobs/search/SimilarJobsResultList";

const LatestJobsCard = (props) => {
  return <SimilarJobsResultList query={[]} currentJobId={null} />;
};

export default LatestJobsCard;
